import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument  } from '@angular/fire/firestore';
import { Post } from '../../models/models';
 
@Injectable()
export class PostService {
	
	private urlPath = '/posts';
	
	private postsCollection: AngularFirestoreCollection<Post>;
 
    //private postListRef = this.db.list<Post>(this.urlPath);
 
    constructor(private afs: AngularFirestore) { }
 
    getPostList(first,last) {
		if(!first){
			return this.afs.collection(this.urlPath,ref=>ref.orderBy('timestamp').limit(last));
		}else{
			 return this.afs.collection(this.urlPath,ref=>ref.orderBy('timestamp').startAt(first).limit(last));
		}
    }
 
	getPost(key:string){
		return this.afs.doc<Post>(`${this.urlPath}/${key}`)
	}
	
    addPost(post: Post) {
		let id = this.afs.createId();
		this.afs.collection<Post>(this.urlPath).doc(id).set(post);
		return id;
    }
 
    updatePost(key:string,post: Post) {
		return	this.afs.doc<Post>(`${this.urlPath}/${key}`).update(post);	
    }
 
    removePost(key:string) {
		return	this.afs.doc<Post>(`${this.urlPath}/${key}`).delete();	
    }
}


